export const API = '[API]';

export const types = {
    API_REQUEST: `${API} request`,
    API_SUCCESS: `${API} success`,
    API_FAIL: `${API} fail`,
};
